'use strict';

exports.__esModule = true;
exports.preventUrlSearch = exports.urlChanged = exports.buildMobileSearchQueryString = exports.buildSearchParameters = exports.buildSearchString = exports.populateAvailabities = exports.searchAndUpdate = exports.searchType = exports.noop = exports.areLoaded = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _constants = require('./constants');

var _searchResults = require('../transformers/search-results');

var _doctifyUtils = require('doctify-utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 imports
 **/

var areLoaded = exports.areLoaded = function areLoaded(list, keys) {
  return !keys.map(function (key) {
    return list[key] && list[key].length;
  }).filter(function (item) {
    return !item;
  }).length;
}; /**
    Constants
    **/


var removeUndefinedParameters = function removeUndefinedParameters(parameterObject) {
  (0, _keys2.default)(parameterObject).forEach(function (parameter) {
    if (!parameterObject[parameter]) {
      delete parameterObject[parameter];
    }
  });
};

/**
 util functions
 **/
var noop = exports.noop = function noop() {};

var searchType = exports.searchType = function searchType(location) {
  return location && location.query && location.query.search_type && location.query.search_type;
};

/* Nice function to update the search parameters and load the search */
var searchAndUpdate = exports.searchAndUpdate = function searchAndUpdate(updateState, search, searchParameters, parametersNames) {
  /* here we use a function because the Arguments parameter needs a context */
  return function () /*unkown number of arguments*/{
    var _arguments = arguments;

    var parametersToUpdate = {};
    parametersNames = (0, _isArray3.default)(parametersNames) ? parametersNames : [parametersNames];
    parametersNames.forEach(function (parameter, index) {
      /*[...arguments] is an array populated with the arguments sent to the function.*/
      parametersToUpdate[parameter] = [].concat(Array.prototype.slice.call(_arguments))[index];
    });
    var newSearchParameters = (0, _extends3.default)({}, searchParameters.advancedSearchBar, parametersToUpdate, {
      route: searchParameters.route,
      listings: searchParameters.listings
    });
    updateState.apply(undefined, [].concat(Array.prototype.slice.call(arguments)));
    search(newSearchParameters);
  };
};

var populateAvailabities = exports.populateAvailabities = function populateAvailabities(results, populate, props) {
  return results.map(function (result) {
    if (!result.availabilityLoaded && (result.hasBookings || result.isBmi || result.isRamsay || result.isSpire || result.isNuffield) && result.profileType === 'specialist') {
      populate(result.ApiProfileUrl, result.id, props);
      return result;
    } else {
      return result;
    }
  });
};

var buildSearchString = exports.buildSearchString = function buildSearchString(searchProps) {
  var selectedKeyword = searchProps.selectedKeyword;
  var searchString = {
    text: selectedKeyword ? undefined : searchProps.text,
    page: searchProps.selectedPage || undefined,
    gender: searchProps.selectedGender || undefined,
    sort: searchProps.selectedSortType && searchProps.selectedSortType.value || undefined,
    search_type: searchProps.searchType || _constants.APPOINTMENTS,
    types_filter: searchProps.searchType !== _constants.APPOINTMENTS ? '01' : '11',
    insurer: searchProps.selectedInsurer ? searchProps.selectedInsurer.name : undefined,
    language: searchProps.selectedLanguage ? searchProps.selectedLanguage.name : undefined,
    location: searchProps.selectedLocation ? searchProps.selectedLocation.name : undefined,
    search_radius: searchProps.selectedWithin ? searchProps.selectedWithin.value : undefined,
    scan: searchProps.searchType === _constants.SCANS && (selectedKeyword && selectedKeyword.name || 'All') || undefined,
    condition: selectedKeyword && (selectedKeyword.type === 'condition' || selectedKeyword.keyword_type === 'condition') && selectedKeyword.name || undefined,
    procedure: selectedKeyword && (selectedKeyword.type === 'procedure' || selectedKeyword.keyword_type === 'procedure') && selectedKeyword.name || undefined,
    specialty: searchProps.searchType === _constants.APPOINTMENTS && selectedKeyword && (selectedKeyword.type === 'specialty' || selectedKeyword.keyword_type === 'specialty') && selectedKeyword.name || undefined,
    healthCheck: searchProps.searchType === _constants.HEALTH_CHECK && (selectedKeyword && selectedKeyword.name || 'All') || undefined,
    enddate: searchProps.selectedDates && searchProps.selectedDates.length > 1 ? searchProps.selectedDates[1].format('YYYY-MM-DD') : undefined,
    startdate: searchProps.selectedDates && searchProps.selectedDates.length > 1 ? searchProps.selectedDates[0].format('YYYY-MM-DD') : undefined,
    search_center: searchProps.autocomplete && searchProps.autocomplete.location_search_center && searchProps.autocomplete.location_search_center.latitude + ',' + searchProps.autocomplete.location_search_center.longitude || searchProps.selectedLocation && searchProps.selectedLocation.value.lat + ',' + searchProps.selectedLocation.value.lng || undefined,
    videoConsultation: searchProps.videoConsultation || undefined,
    network: selectedKeyword && selectedKeyword.networks && selectedKeyword.networks[0]
  };

  removeUndefinedParameters(searchString);

  return searchString;
};

var buildSearchParameters = exports.buildSearchParameters = function buildSearchParameters(searchProps) {
  var selectedKeywordId = !searchProps.text && searchProps.selectedKeyword && searchProps.selectedKeyword.id;

  var searchParameters = {
    sortorder: 'asc',
    page_limit: _constants.PAGE_SIZE,
    location_filter_class: searchProps.selectedLocation && searchProps.selectedLocation.locationFilterClass || _constants.DEFAULT_FILTER_CLASS,
    string_filter: searchProps.text,
    filter: searchProps.text, /* YES the two endpoints are using different syntax .... */
    gender_filter: searchProps.selectedGender && searchProps.searchType === _constants.APPOINTMENTS && (searchProps.selectedGender === 'male' && 'm' || searchProps.selectedGender === 'female' && 'f') || null,
    types_filter: searchProps.searchType !== _constants.APPOINTMENTS ? '01' : '11',
    page_offset: searchProps.selectedPage ? searchProps.selectedPage - 1 : 0,
    location_filter_center: searchProps.selectedLocation && searchProps.selectedLocation.value ? searchProps.selectedLocation.value.lat + ',' + searchProps.selectedLocation.value.lng : '51.507351,-0.127758',
    search_center: searchProps.selectedLocation && searchProps.selectedLocation.value ? searchProps.selectedLocation.value.lat + ',' + searchProps.selectedLocation.value.lng : '51.507351,-0.127758',
    location_filter_distance: searchProps.selectedWithin ? searchProps.selectedWithin.value : _constants.DEFAULT_WITHIN,
    date_range: searchProps.selectedDates && searchProps.searchType === _constants.APPOINTMENTS && searchProps.selectedDates.length > 1 && '["' + _moment2.default.utc(searchProps.selectedDates[0]).format(_constants.MOMENT_FORMAT) + '", "' + _moment2.default.utc(searchProps.selectedDates[1]).format(_constants.MOMENT_FORMAT) + '"]' || null,
    keyword_filter: selectedKeywordId ||
    // searchProps.searchType === SCANS && getAllTreatmentIds(searchProps.listings.scansTreatmentGroups) ||
    // searchProps.searchType === HEALTH_CHECK && getAllTreatmentIds(searchProps.listings.healthChecksTreatmentGroups) ||
    (searchProps.searchType === _constants.SCANS || searchProps.searchType === _constants.HEALTH_CHECK) && searchProps.selectedHealthCheck && searchProps.selectedHealthCheck.id || null,
    insurer_filter: searchProps.selectedInsurer && searchProps.searchType === _constants.APPOINTMENTS ? searchProps.selectedInsurer.id : null,

    language_filter: searchProps.selectedLanguage && searchProps.searchType === _constants.APPOINTMENTS ? searchProps.selectedLanguage.id : null,
    sort_field: searchProps.selectedSortType && searchProps.searchType === _constants.APPOINTMENTS ? searchProps.selectedSortType.value : 'relevance',
    videoConsultation: searchProps.videoConsultation || null,
    network: selectedKeywordId && searchProps.network || null
  };

  (0, _keys2.default)(searchParameters).forEach(function (parameter) {
    if (!searchParameters[parameter]) {
      delete searchParameters[parameter];
    }
  });

  removeUndefinedParameters(searchParameters);

  return searchParameters;
};

var buildMobileSearchQueryString = exports.buildMobileSearchQueryString = function buildMobileSearchQueryString(mobileSearchMenu, autocomplete) {
  var selectedKeyword = mobileSearchMenu.selectedKeyword;

  var url = '/search?';
  if (selectedKeyword) {
    url += encodeURIComponent(selectedKeyword.keyword_type || selectedKeyword.type).trim() + '=' + encodeURIComponent(selectedKeyword.name).trim() + '&';
  }
  url += selectedKeyword ? 'specialty=' + encodeURIComponent(selectedKeyword.name) + '&' : '';
  url += mobileSearchMenu.selectedInsurer ? 'insurer=' + encodeURIComponent(mobileSearchMenu.selectedInsurer.name) + '&' : '';
  url += 'sort=relevance&';
  url += 'page=1&';
  url += mobileSearchMenu.selectedLocation && !autocomplete.location_search_center ? 'location=' + encodeURIComponent(mobileSearchMenu.selectedLocation.name) + '&' : '';

  if (!mobileSearchMenu.selectedLocation && autocomplete.location_search_center) {
    url += 'search_center=' + encodeURIComponent(autocomplete.location_search_center.latitude) + ',' + encodeURIComponent(autocomplete.location_search_center.longitude) + '&';
  }

  url += 'search_radius=50&types_filter=11&';

  var network = selectedKeyword && selectedKeyword.networks && selectedKeyword.networks[0];
  if (network) {
    url += 'network=' + network + '&';
  }

  url += 'search_type=' + encodeURIComponent(mobileSearchMenu.selectedMenuItem === 'keyword' ? 'appointment' : mobileSearchMenu.selectedMenuItem) + 's';
  return url;
};

var currentUrl = void 0;
var urlChanged = exports.urlChanged = function urlChanged(url) {
  if (url !== currentUrl) {
    currentUrl = url;
    return true;
  } else {
    return false;
  }
};

var preventUrlSearch = exports.preventUrlSearch = function preventUrlSearch(url) {
  currentUrl = url;
};


// WEBPACK FOOTER //
// ./components/search-page/lib/utils/utils.js